'use client';

import { useRouter } from 'next/navigation';
import { useCallback, useEffect, useRef, useState } from 'react';
import styles from '../styles/Home.module.css';

export default function Page() {
    const router = useRouter();
    const [roomId, setRoomId] = useState('');
    const [loading, setLoading] = useState(false);

    // то, что уже было
    const adminPinRef = useRef<string | undefined>(undefined);
    const adminFlagRef = useRef<string | undefined>(undefined);

    // 👇 добавляем хранилище для userName
    const userNameRef = useRef<string | undefined>(undefined);

    const checkAndNavigate = useCallback(
      async (value: string) => {
          const trimmed = value.trim();
          if (!trimmed) return;

          setLoading(true);
          try {
              // собираем query для backend
              const extraQuery =
                (adminPinRef.current ? `&adminPin=${encodeURIComponent(adminPinRef.current)}` : '') +
                (adminFlagRef.current ? `&roomAdmin=${encodeURIComponent(adminFlagRef.current)}` : '') +
                // 👇 если есть userName — тоже пробросим на бэкенд
                (userNameRef.current ? `&userName=${encodeURIComponent(userNameRef.current)}` : '');

              const response = await fetch(
                `/api/connection-details?roomName=${encodeURIComponent(trimmed)}&validateOnly=1${extraQuery}`,
              );

              if (response.ok) {
                  // пробрасываем и на страницу комнаты, чтобы PageClientImpl тоже видел
                  // тут нужно собрать ВСЁ, что у нас есть
                  const qp = new URLSearchParams();
                  if (adminPinRef.current) qp.set('adminPin', adminPinRef.current);
                  if (adminFlagRef.current) qp.set('roomAdmin', adminFlagRef.current);
                  if (userNameRef.current) qp.set('userName', userNameRef.current);

                  const qs = qp.toString();
                  router.push(
                    qs
                      ? `/rooms/${encodeURIComponent(trimmed)}?${qs}`
                      : `/rooms/${encodeURIComponent(trimmed)}`
                  );
              } else if (response.status === 403) {
                  alert('Такого номера комнаты не существует. Проверьте числа и попробуйте снова.');
              } else {
                  const data = await response.json().catch(() => ({}));
                  alert(`Ошибка: ${data.error || 'Не удалось проверить консультацию.'}`);
              }
          } catch (error) {
              console.error('Ошибка проверки комнаты:', error);
              alert('Не удалось подключиться к серверу. Проверьте соединение.');
          } finally {
              setLoading(false);
          }
      },
      [router],
    );

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        await checkAndNavigate(roomId);
    };

    // авто-подстановка и автосабмит при наличии чего-то после "?"
    const autoSubmittedRef = useRef(false);
    useEffect(() => {
        if (autoSubmittedRef.current) return;
        if (typeof window === 'undefined') return;

        const search = window.location.search.startsWith('?')
          ? window.location.search.slice(1)
          : '';
        const sp = new URLSearchParams(search);

        // 1) СЧИТЫВАЕМ userName, которого раньше не было
        const userName = sp.get('userName');

        console.log('111111', userName);
        if (userName) {
            userNameRef.current = userName;
            // заодно сохраним, чтобы /rooms/... тоже смог поднять
            try {
                sessionStorage.setItem('guestName', userName);
            } catch {}
        }

        // подхватываем roomAdmin и adminPin как было
        const roomAdmin = sp.get('roomAdmin');
        if (roomAdmin) adminFlagRef.current = roomAdmin;

        const adminPinStd = sp.get('adminPin');
        if (adminPinStd) adminPinRef.current = adminPinStd;

        // дальше твоя логика про roomName
        let initial = sp.get('roomName') ?? '';

        if (!initial && search && search.includes('&') && !search.includes('=')) {
            const parts = search.split('&').map((s) => {
                try {
                    return decodeURIComponent(s);
                } catch {
                    return s;
                }
            });
            const candidateRoom = parts[0] || '';
            const candidatePin = parts[1] || '';
            if (/^\d{6}$/.test(candidateRoom)) {
                initial = candidateRoom;
            }
            if (candidatePin) {
                adminPinRef.current = candidatePin;
            }
        }

        if (!initial && search && !search.includes('&') && !search.includes('=')) {
            try {
                initial = decodeURIComponent(search);
            } catch {
                initial = search;
            }
        }

        if (initial) {
            autoSubmittedRef.current = true;
            setRoomId(initial);
            checkAndNavigate(initial);
        }
    }, [checkAndNavigate]);

    return (
      <main
        className={styles.main}
        data-lk-theme="default"
        style={{
            minHeight: '100dvh',
            backgroundImage: 'url(/images/bg.jpg)',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        }}
      >
          <div className="header">
              <img
                src="/images/broncorpcolling.png"
                alt="LiveKit Meet"
                width="360"
                height="45"
              />
              <h2>Платформа консультаций В.М. Бронникова</h2>
          </div>
          <div style={{ maxWidth: '400px', margin: '2rem auto' }}>
              <form onSubmit={handleSubmit}>
                  <input
                    type="text"
                    value={roomId}
                    onChange={(e) => setRoomId(e.target.value)}
                    placeholder="Введите номер комнаты"
                    required
                    disabled={loading}
                    style={{ width: '100%', padding: '0.5rem', marginBottom: '1rem' }}
                  />
                  <button
                    type="submit"
                    className="lk-button"
                    style={{ width: '100%' }}
                    disabled={loading}
                  >
                      {loading ? 'Проверка...' : 'Присоединиться'}
                  </button>
              </form>
          </div>
      </main>
    );
}
